import React, {useState} from 'react';

import styles from './stlyes/category-box.module.css';

import Button from '../../common-women/Button';
import ModalWrapper from '../../modal-women/ModalWrapper';

import {ReactComponent as DownloadActive} from '../../../assets/docs-women/download-active.svg';
import {ReactComponent as Download} from '../../../assets/docs-women/download.svg';
import {ReactComponent as PencilActive} from '../../../assets/docs-women/pencil-active.svg';
import {ReactComponent as Pencil} from '../../../assets/docs-women/pencil.svg';
import {ReactComponent as TrashActive} from '../../../assets/docs-women/trash-active.svg';
import {ReactComponent as Trash} from '../../../assets/docs-women/trash.svg';

export default function CategoryBox({ currentId, categoryName, categoryDescription, selectedItems, hanldeDownload }) {
    const [openUpdateModal, setOpenUpdateModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const itemToDo = selectedItems ? selectedItems[0] : {}; // 수정/삭제 할 하나의 카테고리 혹은 문서

    const selectedCount = selectedItems.length;
    
    // 버튼 활성화 조건
    const activeBtn = selectedCount > 0;
    const activeUpdateBtn = selectedCount === 1;

    // 버튼 스타일 설정 함수
    const getBtnStyle = (isActive) => {
        return {
            height: '40px',                             
            padding: '10px 15px',
            backgroundColor: isActive ? 'transparent' : '#F8F8F8',
            border: isActive ? '1.5px solid #825DFC' : 'none',
            borderRadius: '5px',
            fontSize: '14px',
            fontWeight: '500',
            textColor: isActive ? '#825DFC' : '#A9A9AE',
            disabled: isActive ? '' : 'disabled'
        };
    };

    const clickDownloadBtn = () => {
        const docsList = selectedItems.map((item) => ({
            id: item.id,
            type: item.type
        }));

        hanldeDownload(docsList);
    };

    const toggleUpdateModal = () => {
        setOpenUpdateModal(!openUpdateModal);
    };

    const toggleDeleteModal = () => {
        setOpenDeleteModal(!openDeleteModal);
    };

    return (
        <div className={styles.wrapper}>
            <p className={styles.description}>{categoryDescription}</p>
            <div className={styles.categoryBox}>
                <p>{categoryName}</p>
                {currentId === 0 ? null : <Pencil style={{ cursor: 'pointer' }} onClick={selectedCount === 0 ? toggleUpdateModal : null} />}
            </div>
            <div className={styles.btnBox}>
                <Button
                    Icon={activeBtn ? DownloadActive : Download}
                    text='다운로드'
                    width='116px'
                    {...getBtnStyle(activeBtn)}
                    onClick={activeBtn ? clickDownloadBtn : null}
                />
                <Button
                    Icon={activeUpdateBtn ? PencilActive : Pencil}
                    text='수정'
                    width='84px'
                    onClick={toggleUpdateModal}
                    {...getBtnStyle(activeUpdateBtn)}
                />
                <Button
                    Icon={activeBtn ? TrashActive : Trash}
                    text='삭제'
                    width='88px'
                    onClick={toggleDeleteModal}
                    {...getBtnStyle(activeBtn)}
                />
            </div>

            {openUpdateModal &&
                <ModalWrapper 
                    type='update'
                    handleClose={toggleUpdateModal}
                    itemToDo={itemToDo}
                />
            }

            {openDeleteModal &&
                <ModalWrapper 
                    type='delete'
                    handleClose={toggleDeleteModal}
                    itemToDo={itemToDo}
                    itemsToDelete={selectedItems}
                />
            }
        </div>
    );
}
